import { Link } from 'react-router-dom'
import { getItemLink, getItemId, getItemName, getItemIcon } from './utils'
import HighlightText from './HighlightText'
import noFavorite from '../../assets/images/noFavorite.png'
import favorite from '../../assets/images/yesFavorite.png'

interface InteractiveCategoryCardProps {
  item: any
  showingType: 'subcategories' | 'cards'
  hasSubscription?: boolean
  className?: string
  onCategoryClick?: (categoryId: number) => void
  onToggleFavorite?: (itemId: string) => void
  isFavorite?: boolean
  searchQuery?: string
}

const InteractiveCategoryCard = ({
  item,
  showingType,
  hasSubscription,
  className = 'category-card',
  onCategoryClick,
  onToggleFavorite,
  isFavorite,
  searchQuery = '',
}: InteractiveCategoryCardProps) => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const target = e.target as HTMLImageElement
    // Скрываем сломанное изображение
    target.style.display = 'none'
    // Показываем плейсхолдер если он есть
    const placeholder = target.parentElement?.querySelector(
      '.category-placeholder'
    )
    if (placeholder) {
      placeholder.classList.remove('hidden')
    }
  }

  const handleClick = (e: React.MouseEvent) => {
    if (showingType === 'subcategories' && onCategoryClick) {
      e.preventDefault()
      onCategoryClick(item.category_id)
    }
  }

  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (onToggleFavorite) {
      onToggleFavorite(getItemId(item, showingType).toString())
    }
  }

  const showFavoriteButton =
    hasSubscription && showingType === 'cards' && onToggleFavorite

  const content = (
    <>
      <div className="category-image">
        <img
          src={getItemIcon(item)}
          alt={getItemName(item, showingType)}
          onError={handleImageError}
          loading="lazy"
          decoding="async"
        />
        <div className="category-placeholder hidden">
          {getItemName(item, showingType).charAt(0).toUpperCase()}
        </div>
      </div>
      <div className="category-info">
        <h3 className="category-name">
          <HighlightText
            text={getItemName(item, showingType)}
            searchQuery={searchQuery}
          />
        </h3>
      </div>
      {showFavoriteButton && (
        <button
          className={`favorite-button ${isFavorite ? 'favorite-active' : ''}`}
          onClick={handleFavoriteClick}
          title={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
        >
          {isFavorite ? (
            <img src={favorite} alt="favorite" className="favorite-icon" />
          ) : (
            <img src={noFavorite} alt="noFavorite" className="favorite-icon" />
          )}
        </button>
      )}
    </>
  )

  return (
    <Link
      key={getItemId(item, showingType)}
      to={getItemLink(item, showingType)}
      className={className}
      onClick={handleClick}
    >
      {content}
    </Link>
  )
}

export default InteractiveCategoryCard
